import React from 'react'
import {ResponsiveTable} from "../../../../layout/Table/ResponsiveTable";
import {TableHead} from "./TableHead";
import {TableBody} from "./TableBody";

const TableComponent = ({users, applySort, actionCallback}) => {
  return (
    <ResponsiveTable>
      <TableHead
        applySort={applySort}
      />
      <TableBody
        actionCallback={actionCallback}
        users={users}
      />
    </ResponsiveTable>
  )
}

export {
  TableComponent
}
